<template>
        <div>
            <password-input
              :error="newPasswordErrorValue"
              :name="name"
              :label="label"
              :id="id"
              :placeholder="placeholder"
              :value="newPasswordValue"
              :is-required="isRequired"
              @input="validateNewPassword"
            ></password-input>
        </div>
</template>

<script>

import {validatePasswordWithMsg} from "../../tools/validation";

export default {
    props: {
        password: {
            default: ''
        },
        passwordError: {
            default: ''
        },
        isRequired: {
            type: Boolean,
            default: false
        },
        label: String,
        name: String,
        id: String,
        placeholder: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            newPasswordValue: this.password,
            newPasswordErrorValue: this.passwordError,
        }
    },
    methods: {
        validateNewPassword(value) {

            this.newPasswordValue = value;
            let msg = validatePasswordWithMsg(value);

            if (msg) {
                this.newPasswordErrorValue = msg.join("<br> ");
            } else {
                this.newPasswordErrorValue = '';
            }
        },
        checkHasErrors() {
            return this.newPasswordErrorValue;
        },
    },
    computed: {
        token() {
            return document.head.querySelector('meta[name="csrf-token"]').content;
        }
    }
}
</script>
